var map = {
	"./caja.svg": "b474",
	"./cash-lock.svg": "812a",
	"./idt-icon/fonts/idt-icon.svg": "df20",
	"./idt-icon/fonts/idticon.svg": "83e3",
	"./info-info.svg": "edd7",
	"./info-warning.svg": "bd8e",
	"./salir.svg": "f571",
	"./secure-blue.svg": "079d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";